module.exports = __webpack_public_path__ + "static/media/zw.fd0361e1.svg";